import CreateInvestmentError from './CreateInvestmentError';
class PropertyIsNotActive extends CreateInvestmentError {
    constructor(options) {
        super('Property is not active', options);
    }
}
export default PropertyIsNotActive;
